/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gradient/run time`)
};

const es_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiempo de gradiente/corrida`)
};

const de_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gradienten-/Laufzeit`)
};

const nl_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gradiënt-/looptijd`)
};

const fr_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Temps de gradient/run`)
};

const it_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo gradiente/corsa`)
};

const pt_br2_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de gradiente/corrida`)
};

const pt_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempo de gradiente/corrida`)
};

const ja_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`グラジエント/実行時間`)
};

const zh_hplc_gradient = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`梯度/运行时间`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hplc_gradient = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hplc_gradient(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hplc_gradient", locale)
	if (locale === "en") return en_hplc_gradient(inputs)
	if (locale === "es") return es_hplc_gradient(inputs)
	if (locale === "de") return de_hplc_gradient(inputs)
	if (locale === "nl") return nl_hplc_gradient(inputs)
	if (locale === "fr") return fr_hplc_gradient(inputs)
	if (locale === "it") return it_hplc_gradient(inputs)
	if (locale === "pt-BR") return pt_br2_hplc_gradient(inputs)
	if (locale === "pt") return pt_hplc_gradient(inputs)
	if (locale === "ja") return ja_hplc_gradient(inputs)
	return zh_hplc_gradient(inputs)
};